export const rowsPerPageOptions = [5, 10, 15] as const
